import { ChevronDown } from "lucide-react";
import { FAQ_ITEMS } from "@jipraks/shared";
import { SectionHeading } from "@client/components/ui/SectionHeading";
import { layoutCopy } from "@client/locales/id/layout";

/** Native <details>: accessible and keyboard-friendly without any state. */
export function FaqSection() {
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-16 sm:px-6 md:py-24">
      <SectionHeading eyebrow={layoutCopy.faq.eyebrow} title={layoutCopy.faq.title} />
      <div className="mt-10 flex flex-col gap-3">
        {FAQ_ITEMS.map((item) => (
          <details
            key={item.question}
            className="group rounded-2xl border border-border-default bg-surface shadow-inner-highlight transition-colors duration-200 open:border-border-hover"
          >
            <summary className="flex min-h-14 cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left font-medium text-foreground [&::-webkit-details-marker]:hidden">
              {item.question}
              <ChevronDown
                className="size-4 shrink-0 text-foreground-muted transition-transform duration-200 ease-expo-out group-open:rotate-180"
                aria-hidden="true"
              />
            </summary>
            <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-muted">{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
